import { isNil } from 'ramda'

import type { CallingCode } from './calling-codes'

export type PhoneNumber = {
  callingCode: CallingCode | string
  nationalNumber: string
}

export const parsePhoneNumber = (
  callingCodes: CallingCode[],
  phoneNumberValue: string
): PhoneNumber | undefined => {
  const normalizedPhoneNumber = normalizePhoneNumber(phoneNumberValue)

  const currentCallingCode = callingCodes.find((callingCode) =>
    normalizedPhoneNumber.startsWith(callingCode)
  )
  if (isNil(currentCallingCode)) {
    return undefined
  }

  return {
    callingCode: currentCallingCode,
    nationalNumber: normalizedPhoneNumber.slice(currentCallingCode.length),
  }
}

export const getFullPhoneNumber = ({
  callingCode,
  nationalNumber,
}: PhoneNumber) => `${callingCode}${nationalNumber}`

export const normalizePhoneNumber = (phoneNumber: string) =>
  phoneNumber.replace(/[^+0-9*]/g, '')
